import { logError } from 'utils/datadog';
import { getDB } from 'utils/idb';
import {
  CV_BUILDER_FORM_KEY,
  DB_NAME,
  DB_VERSION,
  STORE_NAME
} from './constants';
import { CVBuilderDBValues, CVBuilderFormValues } from './types';
import { transformDBToForm, transformFormToDB } from './utils';

const getFormDB = () => getDB(DB_NAME, DB_VERSION, STORE_NAME);

export const saveCVFormData = async (
  formValues: CVBuilderFormValues
): Promise<void> => {
  const transformedData = transformFormToDB(formValues);
  await saveFormData(transformedData);
};

export const saveFormData = async <T>(data: T): Promise<void> => {
  try {
    const db = await getFormDB();
    await db.put(STORE_NAME, data, CV_BUILDER_FORM_KEY);
  } catch (error) {
    logError(
      `Failed to save form data for key "${CV_BUILDER_FORM_KEY}"`,
      error
    );
  }
};

export const loadCVFormData = async (): Promise<
  CVBuilderFormValues | undefined
> => {
  const data = await loadFormData<CVBuilderDBValues>();
  if (!data) return undefined;

  return transformDBToForm(data);
};

export const loadFormData = async <T>(): Promise<T | undefined> => {
  try {
    const db = await getFormDB();
    return db.get(STORE_NAME, CV_BUILDER_FORM_KEY) as Promise<T | undefined>;
  } catch (error) {
    throw new Error('Failed to load form data');
  }
};

export const clearCVFormData = async () => {
  try {
    const db = await getFormDB();
    await db.delete(STORE_NAME, CV_BUILDER_FORM_KEY);
  } catch (error) {
    logError(
      `Failed to clear form data for key "${CV_BUILDER_FORM_KEY}"`,
      error
    );
  }
};
